<template>
    <side-bar-page>
    <template slot="content">
        <div class="content content-m">

              <b-modal v-model="showReviewModal"
                        :title="$t('r_send_feedback')"
                        :body-text-variant="'dark'"
                        :footer-text-variant="'dark'"
                        :headerClass="'message-header'"
                        :modalClass="'message-modal'"
                        :footerClass="'message-footer'"
                        :hide-footer="true"
                        >
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-md-12 disable-col-padding">
                                <label class="card-label">{{$t('r_review_mark')}}</label>
                                <div class="row">
                                  <div class="col-md-6">
                                    <vue-slider 
                                        class="mark-slider"
                                        v-model="newReview.mark" 
                                        :min="-1" 
                                        :max="5" 
                                        :tooltip="'always'"
                                        :tooltipPlacement="'top'"
                                        :interval="1"
                                        >
                                    </vue-slider>
                                  </div>
                                </div>
                                <br>
                                <div class="form-group">
                                    <textarea v-model="newReview.text" class="form-control text-message" :placeholder="$t('r_placeholder_feedback')" style="height: 100px;"></textarea>
                                </div>
                                <div class="form-group has-label">
                                  <input type="checkbox" name="checkBoxAnon" id="checkBoxAnon" v-model="newReview.isAnonymous" :disabled="true"/>
                                  <label class="form-radio card-label" for="checkBoxAnon" :disabled="true"><span>{{$t('r_review_anonymously')}}</span></label>
                                </div>
                                <div class="row">
                                  <div class="col-md-6 col-12">

                                  </div>
                                  <div class="col-md-6 col-12">
                                    <button v-if="!isSendingReview" class="btn btn-fill float-right btn-primary btn-rounded" type="button" @click="sendReview()">
                                      {{$t('r_send_feedback')}}
                                    </button>
                                  </div>
                                </div>
                                <spinner-loader v-if="isSendingReview" class="text-center" color="blue"></spinner-loader>
                            </div>
                        </div>
                    </div>
                </b-modal>

                <b-modal v-model="showEditModal"
                        :title="$t('r_edit_feedback')"
                        :body-text-variant="'dark'"
                        :footer-text-variant="'dark'"
                        :headerClass="'message-header'"
                        :modalClass="'message-modal'"
                        :footerClass="'message-footer'"
                        :hide-footer="true"
                        >
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-md-12 disable-col-padding">
                                <label class="card-label">{{$t('r_review_mark')}}</label>
                                <div class="row">
                                  <div class="col-md-6">
                                    <vue-slider 
                                        class="mark-slider"
                                        v-model="reviewEdit.mark" 
                                        :min="-1" 
                                        :max="5" 
                                        :tooltip="'always'"
                                        :tooltipPlacement="'top'"
                                        :interval="1"
                                        >
                                    </vue-slider>
                                  </div>
                                </div>
                                <br>
                                <div class="form-group">
                                    <textarea v-model="reviewEdit.review" class="form-control text-message" :placeholder="$t('r_placeholder_feedback')" style="height: 100px;"></textarea>
                                </div>
                                <div class="form-group has-label">
                                  <input type="checkbox" name="checkBoxAnon2" id="checkBoxAnon2" v-model="reviewEdit.isAnonymous" :disabled="true"/>
                                  <label class="form-radio card-label" for="checkBoxAnon2" :disabled="true"><span>{{$t('r_review_anonymously')}}</span></label>
                                </div>
                                <div class="row">
                                  <div class="col-md-6 col-12">

                                  </div>
                                  <div class="col-md-6 col-12">
                                    <button v-if="!isUpdatingReview" class="btn btn-fill float-right btn-primary btn-rounded" @click="updateReview()">
                                      {{$t('r_update_feedback')}}
                                    </button>
                                  </div>
                                </div>
                                <spinner-loader v-if="isUpdatingReview" class="text-center" color="blue"></spinner-loader>
                            </div>
                        </div>
                    </div>
                </b-modal>

                <b-tabs v-model="tabIndex" content-class="mt-3 container-fluid" class="rating-tab">
                  <b-tab active @click="loadMyReviews()" :title="$t('r_my_reviews')">

                    <div class="col-md-12 disable-col-padding-m">
                      <div v-if="!reviews || reviews.length < 1">

                        <div class="review-empty-block">
                          <p class="review-empty">
                            {{$t('r_review_empty0')}}<br>
                            {{$t('r_review_empty1')}}<br>
                            {{$t('r_review_empty2')}}
                          </p>
                          <div class="text-center">
                            <button class="btn btn-filter btn-filter-alt review-btn" type="button" @click="openReviewsSearch()">
                              <i class="fa fa-pencil-square-o"></i> {{$t('r_review_btn')}}
                            </button>
                            <button class="btn btn-filter btn-filter-alt review-btn2" type="button" @click="openReviewsSearch()">
                              <i class="fa fa-search"></i> {{$t('r_review_btn_search')}}
                            </button>
                          </div>
                        </div>

                      </div>
                      <div class="card card-review" v-for="(review, reviewIndex) in reviews" :key="reviewIndex" :id="'post'+reviewIndex">
                        <div class="row">
                          <div class="col-md-12">
                            <div class="about-user">
                              <span>{{$t('r_review_about')}} </span> <a :href="'/profile/'+review.reviewAboutId" target="_blank">{{review.firstName}} {{review.lastName}}:</a>
                            </div>
                            <div class="control-btn">
                              <b-button size="sm" variant="outline-danger" :title="$t('edit')" @click="editReview(review)" class="btn-control-min"><i class="fa fa-pencil"></i></b-button>
                              <b-button size="sm" variant="outline-danger" :title="$t('delete')" @click="deleteReview(review.id)" class="btn-control-min"><i class="fa fa-times"></i></b-button>
                            </div>
                          </div>
                        </div>

                        <div class="row review-text">
                          <div class="col-md-2">
                            <a class="img-review-link" :href="'/profile/' + review.id" target="_blank">
                              <div class="img-review-block">
                                <img :src="currentAvatar" class="img-avatar img-review"/>
                                <h5>{{getUserProfile.firstName}} {{getUserProfile.lastName}}</h5>
                              </div>
                            </a>
                          </div>
                          <div class="col-md-10">
                            <div class="row">
                              <div class="col-md-12">
                                <div class="message-review">
                                  <i class="fa fa-quote-left" v-if="review.review && (review.review.length > 0)"></i>
                                  {{review.review}}
                                  <i class="fa fa-quote-right" v-if="review.review && (review.review.length > 0)"></i>
                                </div>
                              </div>
                            </div>

                            <div class="row review-end-block">
                              <div class="col-md-6 col-12">
                                <div class="col-md-8 col-12 disable-col-padding-m">
                                  <span class="mark-label">{{$t('r_review_mark')}}</span>
                                  <vue-slider 
                                    class="mark-slider"
                                    v-model="review.mark" 
                                    :min="-1" 
                                    :max="5" 
                                    :tooltip="'always'"
                                    :tooltipPlacement="'top'"
                                    :useKeyboard="false"
                                    :interval="1" 
                                    :clickable="false"
                                    :disabled="true"
                                    >
                                  </vue-slider>
                                </div>
                              </div>
                              <div class="col-md-6 col-12">
                                <div class="author-review date text-right">
                                  <!-- <span>{{$t('r_review_by')}}</span><br> -->
                                  <span>{{$t('created')}}</span>
                                  <!-- <span v-if="review.author">{{review.author}}</span> -->
                                  <!-- <span v-if="!review.author">{{$t('r_review_noname')}}</span> -->
                                  {{dateFormatter(review.created)}}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                  </b-tab>

                  <b-tab :title="$t('r_all_feedback')" @click="applyFilters(true)">
                    <div v-if="isSearching">
                      {{$t('loading')}}...
                      <spinner-loader color="red"></spinner-loader>
                    </div>
                    <div v-show="!isSearching" class="container-fluid">
                      <div class="row">
                        <div class="col-md-12 result-block" id="second">
                          <!-- <div class="form-group has-label input-group search-input">
                            <span>
                              <i class="fa fa-search" aria-hidden="true"></i>
                            </span>
                            <input type="text" class="form-control" :placeholder="$t('s_filters_name')" @keydown.enter="applyFilters()" v-model="searchFilter.name">
                            <i v-if="searchFilter.name && searchFilter.name.length > 0" class="fa fa-times" @click="clearQuery()"></i>
                          </div> -->
                          <div class="form-group has-label input-group search-input">
                            <span>
                              <i class="fa fa-search" aria-hidden="true"></i>
                            </span>
                            <input type="text" class="form-control" :placeholder="$t('s_filters_name')" @keydown.enter="applyFilters()" v-model="searchFilter.name">
                            <button class="btn btn-default btn-search" @click="applyFilters()">{{$t('search')}}</button>
                          </div>
                          <p v-if="!isSearching && !users.length" class="text-center no-find">{{$t('noFind')}}...</p>
                          <div v-for="(user, userIndex) in users" :key="user.id">
                              <div class="row">
                                <div class="col-md-6 search-result">
                                  <b-media>
                                    <b-img slot="aside" :src="user.avatar" width="80" height="80" class="img-avatar"/>
                                    <div v-if="user.userCategory==='artist'">
                                      <a :href="'/profile/' + user.id" target="_blank"><h5>{{user.firstName}} {{user.lastName}}</h5></a>
                                      <p v-if="user.googlePlaceLocales && user.googlePlaceLocales[currentLng]">{{user.googlePlaceLocales[currentLng].formatted_address}}</p>
                                      <p>{{$t('artist')+' '+getArtistTypesList(user.artistTypesList)}}</p>
                                    </div>
                                    <div v-if="user.userCategory==='agent'">
                                      <a :href="'/profile/' + user.id" target="_blank"><h5>{{user.firstName}} {{user.lastName}}</h5></a>
                                      <p v-if="user.googlePlaceLocales && user.googlePlaceLocales[currentLng]">{{user.googlePlaceLocales[currentLng].formatted_address}}</p>
                                      <p>{{$t('pr_m_agent')}}</p>
                                    </div>
                                    <div v-if="user.userCategory==='employer'">
                                      <a :href="'/profile/' + user.id" target="_blank"><h5>{{user.firstName}} {{user.lastName}}</h5></a>
                                      <p v-if="user.googlePlaceLocales && user.googlePlaceLocales[currentLng]">{{user.googlePlaceLocales[currentLng].formatted_address}}</p>
                                      <p>{{$t('pr_m_employer')}}</p>
                                    </div>
                                    <div v-if="user.userCategory==='team'">
                                      <a :href="'/profile/' + user.id" target="_blank"><h5>{{user.teamName}} ({{user.numberOfPersons}} человек)</h5></a>
                                      <p v-if="!!user.country">{{user.city}}, {{user.country}}</p>
                                      <p>{{$t('team')+' '+getArtistTypesList(user.artistTypesList)}}</p>
                                    </div>
                                  </b-media>
                                </div>
                                <div class="col-md-6">
                                  <div class="profile-btn-block">
                                    <button class="btn btn-filter-alt btn-filter-alt-i profile-btn" @click="showModalReview(user.id)">
                                      <i class="fa fa-pencil-square-o"></i>{{$t('r_send_feedback')}}
                                    </button>
                                    <button class="btn btn-filter-alt btn-filter-i profile-btn read-feedback" @click="showReview(userIndex, user)">
                                      <i class="fa fa-eye"></i>
                                      <span v-if="!user.showReview">{{$t('r_read_feedback')}}</span>
                                      <span v-if="user.showReview">{{$t('r_read_feedback_hide')}}</span>
                                    </button>
                                  </div>
                                </div>
                              </div>

                              <div class="container-fluid">
                                <b-collapse :id="'userReview'+userIndex" v-model="user.showReview">
                                    <div class="row show-row-review">
                                      <div class="col-md-6 col-12 disable-col-padding-m" v-for="(review, reviewIndex) in reviews2" :key="reviewIndex" :id="'post'+reviewIndex">
                                        <div class="card card-review show-card-review">
                                          <div class="row">
                                            <div class="col-md-3">
                                              <a v-if="!review.isAnonymous" class="img-review-link" :href="'/profile/' + review.id" target="_blank">
                                                <div class="img-review-block">
                                                  <img :src="review.avatar" class="img-avatar img-review show-img-review"/>
                                                  <h5>{{review.firstName}} {{review.lastName}}</h5>
                                                </div>
                                              </a>
                                              <a v-if="review.isAnonymous" class="img-review-link" :href="'/profile/' + getUserProfile.id" target="_blank">
                                                <div class="img-review-block">
                                                  <img src="../assets/img/face_default.jpg" class="img-avatar img-review show-img-review"/>
                                                  <h5>{{$t('r_review_noname')}}</h5>
                                                </div>
                                              </a>
                                            </div>
                                            <div class="col-md-9">
                                              <div class="row">
                                                <div class="col-md-12">
                                                  <div class="message-review show-message-review">
                                                    <i class="fa fa-quote-left" v-if="review.review && (review.review.length > 0)"></i>
                                                    {{review.review}}
                                                    <i class="fa fa-quote-right" v-if="review.review && (review.review.length > 0)"></i>
                                                    <p class="empty-review" v-if="!review.review || !review.review.length || (review.review.length < 1)">{{$t('r_review_empty')}}</p>
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="row">
                                                <div class="col-md-6 col-12">
                                                  <div class="col-md-8 col-12 disable-col-padding-m">
                                                    <span class="mark-label">{{$t('r_review_mark')}}</span>
                                                    <vue-slider 
                                                      class="mark-slider"
                                                      v-model="review.mark" 
                                                      :min="-1" 
                                                      :max="5" 
                                                      :tooltip="'always'"
                                                      :tooltipPlacement="'top'"
                                                      :useKeyboard="false"
                                                      :interval="1" 
                                                      :clickable="false"
                                                      :disabled="true"
                                                      >
                                                    </vue-slider>
                                                  </div>
                                                </div>
                                                <div class="col-md-6 col-12">
                                                  <div class="author-review date text-right">
                                                    <!-- <span>{{$t('r_review_by')}}</span><br> -->
                                                    <!-- <span v-if="review.author">{{review.author}}</span>
                                                    <span v-if="!review.author">{{$t('r_review_noname')}}</span> -->
                                                    <span>{{$t('created')}}</span> {{dateFormatter(review.created)}}
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="col-md-12" v-if="reviews2.length < 1">
                                          <p class="no-reviews">{{$t('r_no_reviews')}}</p>
                                      </div>
                                    </div>
                                </b-collapse>
                              </div>

                              <hr>

                          </div>

                          <b-pagination v-if="maxPage>1" v-model="currentPage" :total-rows="allSearchCount" :per-page="countPerPageS" size="md" align="center" @input="setPage"/>
                        </div>
                      </div>
                    </div>
                  </b-tab>

                </b-tabs>
        </div>
    </template>
    </side-bar-page>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import SideBarPage from '../components/SideBarPage';
  import {USER_SEARCH, USER_AVATAR_LOAD} from "../store/actions/userConst";
  import {GOOGLE_GET_PLACE} from "../store/actions/langConst";
  import {REVIEW_ADD, REVIEW_GET_AUTHOR, REVIEW_UPDATE, REVIEW_DELETE, REVIEW_GET_USER, REVIEW_GET_LIST_ID} from "../store/actions/reviewConst";
  import SpinnerLoader from 'vue-spinner/src/PulseLoader.vue';
  import VueSlider from 'vue-slider-component';
  import swal from 'sweetalert2';

  import 'vue-slider-component/theme/default.css';
  var moment = require('moment');
  moment().format();

  export default {
    name: 'search',
    data() {
      return {
        users: [],
        cacheAvatars: [],
        RxLngPointer: null,
        currentPage: 1,
        allSearchCount: 0,
        maxPage: 1,

        selectUserType: null,
        selectArtistType: null,
        selectArtistCategories: null,
        selectArtistSkill: null,
        searchFilter: { googlePlaceLocales: {}, city: '', country: '', name: null, len: 0, height: 0, width: 0, weight: 0 },

        queryArr: [],
        showPropsFilter: false,
        showReviewModal: false,
        showEditModal: false,
        newReview: { mark: 5, isAnonymous: false },
        reviewEdit: {},
        writeReviewFor: null,
        currentAvatar: null,
        reviews: [],
        reviews2: [],
        tabIndex: 0,
        listUsersWithReviews: null,

      }
    },
    beforeDestroy() {
      this.RxLngPointer.unsubscribe();
    },
    mounted() {
      this.RxLngPointer = this.RxLng.subscribe(()=> {
        this.updateGooglePlace();
      });
    },
    created() {
      this.searchFilter.name = '';
      for (let i = 0, len = this.users.length; i < len; i++) {
        this.users[i].showReview = false;
        this.users[i].review = {};
      }
      this.loadMyReviews();
      this.applyFilters(true);
    },
    computed: {
      ...mapGetters(['isSearching', 'getUserProfile', 'currentLng', 'RxLng', 'countPerPageS', 'isUpdatingReview', 'isSendingReview','getArtistTypes']),
    },
    methods: {
      ...mapActions([USER_SEARCH,USER_AVATAR_LOAD,GOOGLE_GET_PLACE,REVIEW_ADD, REVIEW_GET_AUTHOR, REVIEW_UPDATE, REVIEW_DELETE, REVIEW_GET_USER, REVIEW_GET_LIST_ID]),
      dateFormatter(date) {
        return moment(date).format('DD.MM.YYYY');
      },
      setPage() {
        this.applyFilters();
      },
      getArtistTypesList(artistTypesList) {
        let ids = []
        artistTypesList.forEach(x=>ids.push(x.artistTypeId))
        let res = '' 
        this.getArtistTypes.filter(t=>~ids.indexOf(t.id)).forEach(f=>res=res+f[`type_${this.currentLng}`]+',')
        if(res.length) {
          return `(${res.slice(0,-1)})`
        } else {
          return res
        }
      },
      startSearch(query) {
        this.USER_SEARCH({query: query, skip: (this.currentPage-1)*this.countPerPageS, limit: this.countPerPageS})
          .then(res=>{
            this.users = JSON.parse(JSON.stringify(res.users));
            this.allSearchCount = res.allSearchCount;
            this.maxPage = parseInt(this.allSearchCount/this.countPerPageS) + ((this.allSearchCount % this.countPerPageS)?1:0)
            if(this.maxPage) {
              if(this.currentPage > this.maxPage) {
                this.currentPage = this.maxPage;
              } 
            }
            this.updateGooglePlace()
            this.users.forEach(u => {
              // Обновляем кеш аватарок
              if(!~this.cacheAvatars.findIndex(c=>c.id===u.id)) {
                this.cacheAvatars.push({id: u.id})
              }
            })
            this.cacheAvatars.forEach(c => {
              if(!c.avatar) {
                this.USER_AVATAR_LOAD(c)
                  .then((img)=>{
                    c.avatar = img
                    this.users.filter(u=>u.id===c.id).forEach(u1=>u1.avatar=c.avatar)
                    this.users.push({})
                    this.users.splice(this.users.length-1,1)
                  })
                  .catch((err)=>console.log(err))
              } else {
                this.users.filter(u=>u.id===c.id).forEach(u1=>u1.avatar=c.avatar)
                this.users.push({})
                this.users.splice(this.users.length-1,1)
              }
            })
          })
          .catch((err)=>console.log(err))
      },
      updateGooglePlace() {
        this.users.forEach(user=>{
          if(user.googlePlace) {
            user.googlePlaceLocales = user.googlePlaceLocales || {}
            if(!user.googlePlaceLocales[this.currentLng]) {
              this.GOOGLE_GET_PLACE({place_id: user.googlePlace, language: this.currentLng, fields: ['formatted_address']})
                .then(place=>{
                  user.googlePlaceLocales[this.currentLng]=place
                  this.users.push({})
                  this.users.splice(this.users.length-1,1)
                })
                .catch(err=>console.log(err))
            }
          }
        })
      },
      applyFilters(searchOnlyRated) {
        this.queryArr = [];
        // name - 1
        if (this.searchFilter.name && this.searchFilter.name.length) {
          this.queryArr.push(this.searchFilter.name);
        } else {
          this.queryArr.push('');
        }
        // 2
        this.queryArr.push('');
        // 3
        this.queryArr.push('');
        // 4
        this.queryArr.push('');
        // 5
        this.queryArr.push('');
        // 6
        this.queryArr.push('');
        // 7
        this.queryArr.push('');
        if (searchOnlyRated) {
          this.REVIEW_GET_LIST_ID({})
          .then((res)=>{
            this.listUsersWithReviews = res;
            // usersList - 8
            this.queryArr.push(this.listUsersWithReviews);
            this.startSearch(this.queryArr);
          }).catch((err)=>console.log(err))
        } else {
          this.startSearch(this.queryArr);
        }
      },
      openProfile(id) {
        window.open('/profile/' + id, '_blank');
      },
      clearQuery() {
        this.searchFilter.name = null;
        this.applyFilters(true);
      },
      deleteReview(id) {
        swal({
          title: this.$t('areYouSure'),
          text: this.$t('r_review_delete'),
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          confirmButtonText: this.$t('yesDeleteIt'),
          cancelButtonColor: '#d33',
          cancelButtonText: this.$t('cancel')
        }).then((result) => {
          if (result.value) {
            this.REVIEW_DELETE({
              id: id,
            }).then(()=>{
              this.reviews.splice(id, 1);
            }).catch((err) => {
                console.log(err);
            });
          }
        });
      },
      showReview(id, user) {
        user.showReview = !user.showReview;
        // close all collapse
        for (let i = 0, len = this.users.length; i < len; i++) {
          if (i !== id) {
            this.users[i].showReview = false;
          }
        }
        this.REVIEW_GET_USER({
          id: user.id
        })
        .then((res)=>{
          for (let i = 0, len = res.length; i < len; i++) {
            res[i].avatar = '';
          }
          this.reviews2 = res;
          this.reviews2.forEach(r => {
            this.USER_AVATAR_LOAD({
              id: r.authorId
            }).then((img)=>{
              r.avatar = img;
            });
          });
        }).catch((err)=> {
          console.log(err)
          this.reviews2 = {};
        });
      },
      sendReview() {
        if (this.writeReviewFor) {
          this.REVIEW_ADD({
            review: this.newReview.text,
            mark: this.newReview.mark,
            isAnonymous: this.newReview.isAnonymous,
            authorId: this.getUserProfile.id,
            reviewAboutId: this.writeReviewFor,
          }).then(()=>{
              this.showReviewModal = false;
              this.newReview = {};
              this.writeReviewFor = null;
          }).catch(() => {
              this.showReviewModal = false;
              this.newReview = {};
              this.writeReviewFor = null;
          });
        }
      },
      showModalReview(id) {
        this.showReviewModal = true;
        this.writeReviewFor = id;
      },
      editReview(review) {
        this.reviewEdit = review;
        this.showEditModal = true;
      },
      updateReview() {
        this.REVIEW_UPDATE({
          review: this.reviewEdit.review,
          mark: this.reviewEdit.mark,
          isAnonymous: this.reviewEdit.isAnonymous,
          id: this.reviewEdit.id,
        }).then(()=>{
            this.showEditModal = false;
            this.reviewEdit = {};
        }).catch(() => {
            this.showEditModal = false;
            this.reviewEdit = {};
        });
      },
      loadMyReviews() {
        this.REVIEW_GET_AUTHOR()
        .then((res)=>{
          this.reviews = res;
          // console.log(res);
          this.USER_AVATAR_LOAD({
            id: this.reviews[0].authorId
          }).then((img)=>{
            this.currentAvatar = img;
          });
        }).catch((err)=>console.log(err))
      },
      openReviewsSearch() {
        this.tabIndex = 1;
      },
    },
    components: { SideBarPage, SpinnerLoader, VueSlider },
  }
</script>

<style scoped>
  .content {
      padding-left: 20px;
      padding-right: 20px;
      padding-top: 25px;
  }
  .media-body {
    color: black;
  }
  .img-avatar {
    border-radius: 100px;
    border: 2px solid #eee;
    width: 80px;
    height: 80px;
  }
  .img-avatar.img-review {
    border: 2px solid #007bff;
    width: 90px;
    height: 90px;
  }
  .img-review-block h5 {
    padding-top: 5px;
  }
  .img-review-block h4 {
    font-size: 1rem;
  }
  .img-review-link:hover {
    color: #007bff !important;
  }
  .img-review-link {
    color: #007bff !important;
  }
  .img-review-block {
    width: 100%;
    text-align:center;
  }
  .review-text {
    margin-top: 50px;
  }
  select:disabled {
    cursor: not-allowed;
    background-color: #e9ecef;
    color: #bdbdbd !important
  }
  .result-block {
    padding-top: 10px;
  }
  .search-input span {
    position: absolute;
    top: 11px;
    left: 11px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    z-index: 99999;
    color: #565656;
  }
  .search-input input{
    padding-left: 35px;
    padding-right: 75px;
    outline: none;
    border-radius: 0.25rem !important;
    margin-bottom: 10px;
  }
  .search-input .fa-times {
    position: absolute;
    right: 11px;
    top: 10px;
    z-index: 99999;
    color: #56565696;
    cursor: pointer;
  }
  .search-result p {
    margin-bottom: 5px !important;
  }
  .search-result a {
    color: black !important;
  }
  .search-result a:hover {
    color: black !important;
  }
  .profile-btn {
    width: auto !important;
    text-transform: uppercase;
    font-size: 12.5px;
    font-weight: 600;
  }
  .profile-btn .fa {
    padding-right: 10px;
  }
  .no-find {
    margin-top: 50px;
    margin-bottom: 50px;
  }
  .fa-props-collapse {
    font-size: 11px;
    position: relative;
    bottom: 2px;
    left: 5px;
  }
  .filter-props-collapse {
    margin-bottom: 15px !important;
  }
  .read-feedback {
    margin-left: 25px;
  }
  .profile-btn-block {
    text-align: right;
  }
  .card-review {
    padding: 20px;
    margin-bottom: 20px;
    color: #565656 !important;
    -webkit-box-shadow: 0px 0px 14px 0px rgba(0,0,0,0.1);
    -moz-box-shadow: 0px 0px 14px 0px rgba(0,0,0,0.1);
    box-shadow: 0px 0px 14px 0px rgba(0,0,0,0.1);
  }
  .card-review .control-btn {
    position: absolute;
    right: -3px;
    top: -15px;
  }
  .card-review .about-user {
    position: absolute;
    left: 10px;
    top: 5px;
  }
  .card-review .about-user span {
    font-size: 1rem;
    color: #adadad !important;
  }
  .card-review .about-user a,
  .card-review .about-user a:hover {
    font-size: 1rem;
    color: #adadad !important;
    text-decoration: underline;
    cursor: pointer;
  }
  .card-review .btn-outline-danger {
    margin-right: 3px;
  }
  .card-review .status-post {
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .card-review .status-post .fa {
    margin-right: 5px;
  }
  .card-review .message-review {
    background-color: white; 
    padding: 0px 10px 10px 10px;
    height: auto; 
    overflow-y: auto;
  }
  .card-review .message-review.attachments {
    border: 1px solid #007BFF;
    border-radius: 0.25rem;
    margin-bottom: 10px;
    padding: 30px 20px 20px 20px!important;
  }
  .card-review .message-review.attachments .attachments-label {
    position: relative;
    top: -25px;
    left: 0;
    right: 0;
    text-align: center;
  }
  .card-review .message-review .fa-quote-left {
    padding-right: 15px;
    color: #565656a8;
  }
  .card-review .message-review .fa-quote-right {
    padding-left: 15px;
    color: #565656a8;
  }
  .card-review .author-review {
    margin-top: 0px;
  }
  .author-review.date {
    color: #adadad !important;
  }
  .author-review.date:hover {
    color: #565656 !important;
  }
  .mark-slider {
    margin-top: 5px;
    /* margin-bottom: 10px; */
  }
  .mark-label {
    color: #adadad !important;
    position: absolute;
    top: -25px;
  }
  .review-end-block {
    margin-top: 25px;
  }
  .show-message-review-comment {
    height: auto !important;
    /* margin-bottom: 25px; */
  }
  .show-message-review {
    height: 150px !important;
    margin-bottom: 25px;
  }
  .show-message-review::-webkit-scrollbar {
      width: 8px
  }
  .show-message-review::-webkit-scrollbar-thumb {
      background: #007bffe7;
      border-radius: 5px
  }
  .show-message-review::-webkit-scrollbar-thumb:hover {
      background: #007bffe7;
  }
  .show-img-review {
    width: 80px;
    height: 80px;
  }
  .show-card-review {
    /* max-height: 280px; */
  }
  .show-row-review {
    margin-top: 30px;
  }
  .btn-control-min {
    border: none;
  }
  .fa-times {
    font-size: 16px;
  }
  .card-label {
    font-size: 14px;
    margin-bottom: 5px;
    text-transform: uppercase;
    font-weight: 400;
    color: #828080;
  }
  .form-radio {
    font-size: 22px !important;
  }
  .form-radio span {
    font-size: 14px !important;
    padding-left: 5px;
    margin-bottom: 5px;
  }
  .form-radio.card-label span{
    position: relative;
    top: -2px;
  }
  .show-message-review {
    margin-bottom: 40px;
  }
  .review-empty {
    font-size: 1rem;
    color: #565656 !important;
    text-transform: uppercase;
    /* font-weight: 500; */
    text-align: center;
  }
  .review-btn {
    width: auto !important;
  }
  .review-btn2 {
    margin-left: 10px;
    width: auto !important;
  }
  .review-btn .fa {
    padding-right: 5px;
    font-size: 16px;
  }
  .review-empty-block {
    position: relative;
    top:100px;
  }
  .no-reviews {
    color: #565656 !important;
  }
  .how-anon {
    display: block;
    font-size: 1rem;
    color: #828080d4;
    cursor: pointer;
    text-decoration: underline;
  }

  .disclaimer {
    color: #565656 !important;
    text-align: left !important;
  }
  .disclaimer-box {
    border-left: 6px solid #007BFF;
    border-bottom: 1px solid #dee2e6;
    border-top: 1px solid #dee2e6;
    border-right: 1px solid #dee2e6;
    background-color: #f7f7f8;
    padding: 10px 10px 0px 10px;
    margin-bottom: 20px;
    text-align: left !important;
  }
  p.empty-review {
    color: #ADADAD !important;
    margin-top: 70px;
    text-align: center;
  }
  .search-input .btn-search {
    position: absolute;
    right: 0;
    top: 0;
    z-index: 10;
    background-color: #007BFF !important;
    border-color: #007BFF !important;
    color: #ffffff;
    cursor: pointer;
    text-transform: lowercase;
    padding: 6px 8px !important;
    border-radius: 0 0.25rem 0.25rem 0;
  }
  .search-input .btn-search:hover {
    background-color: #007bffe7 !important;
  }
  @media only screen and (max-width: 768px) {
    .profile-btn-block {
      margin-top: 15px;
      text-align: left;
    }
    .profile-btn-block .profile-btn {
      width: 100% !important;
    }
    .result-block {
      padding-left: 0px !important;
      padding-right: 0px !important;
      padding-top: 0px;
    }
    #first {
        order: 1;
    }
    #second {
        order: 2;
    }
    .content {
      padding-top: 10px !important;
    }
    .card-review .control-btn {
      position: absolute;
      right: 0;
      top: -15px;
    }
    .card-review .about-user {
        position: absolute;
        top: 20px;
        left: 15px;
    }
    .review-text {
      margin-top: 65px;
    }
    .card-review .message-review {
      padding: 10px 0 10px 0;
      height: auto; 
      overflow-y: hidden;
    }
    .show-message-review {
      height: auto !important;
      margin-bottom: 25px;
    }
    .card-review .author-review {
      margin-top: 15px;
    }
    .card-review .message-review .fa-quote-right {
        padding-left: 5px;
    }
    .card-review .message-review .fa-quote-left {
        padding-right: 5px;
    }
    .read-feedback {
      margin-left: 0px;
      margin-top: 10px;
    }
    .review-empty-block {
      position: relative;
      top: 20px;
    }
    .review-btn2 {
      width: auto !important;
    }

  }
</style>

<style>
.tab-content.mt-3 {
    margin-top: 0 !important;
    padding-top: 1rem;
    background-color: white !important;
    border-left: 1px solid rgba(0, 0, 0, 0.1);
    border-right: 1px solid rgba(0, 0, 0, 0.1);
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.vue-slider-disabled {
    opacity: 1;
    cursor: not-allowed;
}
.tab-content.mt-3.container-fluid {
    padding-top: 25px !important;
    padding-bottom: 40px;
    min-height: 400px;
}
.highlightText {
  background: yellow;
}
</style>

